import React, { Component } from "react";
import NoDataPlaceholder from "./../../assets/no-kpidata-range.png";
import "./EmptyTable.css";

class EmptyTable extends Component {
  render() {
    const { title, subtitle, customStyles, customImage } = this.props;
    return (
      <div style={{ width: "fit-content" }} className="mt20 noData">
        {/* pb150 */}
        <div className="text-center ">
          <img
            style={customStyles ? customStyles : { height: "150px" }}
            src={customImage ? customImage : NoDataPlaceholder}
          />
          <div
            style={{ marginTop: "0px!important" }}
            className="empty-table-title-text mt20"
          >
            {title}
          </div>
          <div className="empty-table-body-text mt20">{subtitle}</div>
        </div>
      </div>
    );
  }
}

export default EmptyTable;
